import { render, staticRenderFns } from "./MobileCode.vue?vue&type=template&id=223c358c&scoped=true&"
import script from "./MobileCode.vue?vue&type=script&lang=js&"
export * from "./MobileCode.vue?vue&type=script&lang=js&"
import style0 from "./MobileCode.vue?vue&type=style&index=0&id=223c358c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223c358c",
  null
  
)

component.options.__file = "MobileCode.vue"
export default component.exports